if (!customElements.get('worx-catalog')) {
    customElements.define(
        'worx-catalog',
        class WorxCatalog extends HTMLElement {
            connectedCallback() {
                this.tabs = this.querySelectorAll('[data-worx-tab]');
                this.panels = this.querySelectorAll('[data-worx-panel]');
                this.modeButtons = this.querySelectorAll('[data-worx-view]');
                this.grids = this.querySelectorAll('[data-worx-grid]');

                this.tabs.forEach((tab) => {
                    tab.addEventListener('click', this.onTabClick.bind(this));
                    tab.addEventListener('keydown', (event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            this.onTabClick(event);
                        }
                    });
                });

                this.modeButtons.forEach((button) => {
                    button.addEventListener('click', this.onViewClick.bind(this));
                    button.addEventListener('keydown', (event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            this.onViewClick(event);
                        }
                    });
                });

                this.querySelectorAll('a[href^="#"]').forEach((link) => {
                    if (link.closest('[data-worx-tab]')) return;
                    link.addEventListener('click', this.onAnchorClick.bind(this));
                });

                const hashId = window.location.hash.replace('#', '');
                const hashTab = ['signage-letter-routing', 'letter-cut-outs', 'led-grooving'].includes(hashId)
                    ? this.querySelector('[data-worx-tab="signage"]')
                    : null;
                const activeTab = hashTab || this.querySelector('[data-worx-tab].is-active');
                this.activateTab(activeTab || this.querySelector('[data-worx-tab="cabinet"]'));

                if (hashId === 'letter-cut-outs' || hashId === 'led-grooving') {
                    const target = document.getElementById(hashId);
                    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }

            activateTab(tab) {
                if (!tab) return;
                const key = tab.getAttribute('data-worx-tab');

                this.tabs.forEach((item) => {
                    const match = item === tab;
                    item.classList.toggle('is-active', match);
                    item.setAttribute('aria-selected', match ? 'true' : 'false');
                });

                this.panels.forEach((panel) => {
                    const match = panel.getAttribute('data-worx-panel') === key;
                    panel.toggleAttribute('hidden', !match);
                    panel.classList.toggle('is-active', match);
                });

                this.syncFamily(key);
            }

            onTabClick(event) {
                event.preventDefault();
                this.activateTab(event.currentTarget);
            }

            syncFamily(key) {
                const familyEls = document.querySelectorAll('[data-worx-family]');
                if (!familyEls.length) return;

                familyEls.forEach((el) => {
                    const match = el.getAttribute('data-worx-family') === key;
                    el.toggleAttribute('hidden', !match);
                    const section = el.closest('.shopify-section');
                    if (!section || section.contains(this)) return;
                    section.toggleAttribute('hidden', !match);
                });

                this.classList.toggle('is-family-signage', key === 'signage');
            }

            onViewClick(event) {
                const button = event.currentTarget;
                const view = button.getAttribute('data-worx-view');

                this.modeButtons.forEach((item) => {
                    item.classList.toggle('active', item === button);
                });

                this.grids.forEach((grid) => {
                    grid.classList.toggle('worx-catalog__grid--list', view === 'list');
                    grid.classList.toggle('worx-catalog__grid--grid-2', view === 'grid-2');
                });
            }

            onAnchorClick(event) {
                const href = event.currentTarget.getAttribute('href');
                if (!href || href === '#') return;
                const id = href.slice(1);
                const target = document.getElementById(id);
                if (!target) return;

                event.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                history.pushState(null, '', href);
            }
        }
    );
}
